import React from 'react';

interface ICircleImage {
    src?: string;
    className?: string;
}

const CircleImage = ({ src, className = '' }: ICircleImage) => (
    <img src={src} className={className} style={{ borderRadius: '50%', height: 'auto' }} />
);

export default CircleImage;
